<template>
  <div>
    <iq-card>
      <template #headerTitle>
        <h5 class="text-black mb-0"><strong>List Fleet Assigned</strong></h5>
      </template>
      <template #body>
        <form @submit.prevent="handleSubmit">
          <b-alert show variant="primary" class="d-flex align-items-center">
            <i class="fas fa-info-circle mr-2"></i>
            <strong>Information</strong>
            : Unchecklist the fleet below if you want to unassign the job
            library to the fleet.
          </b-alert>

          <!-- Display Not Match Vehicle Engines -->
          <div v-if="groupedNotMatchEngines.length > 0" class="mb-4">
            <b-alert
              v-for="engine in groupedNotMatchEngines"
              :key="engine.engine_id"
              show
              variant="danger"
              class="mb-2 flex align-items-center text-black"
            >
              <i class="fas fa-exclamation-triangle mr-2 text-danger"></i>
              <div class="text-wrap text-black" style="line-height: 1.4">
                <strong class="mr-1">
                  Warning: Data {{ engine.engine_name }} Fleet
                  {{ engine.vehicle_names.join(', ') }},
                </strong>
                cannot be processed because the machine brand is not registered
                in the job library.
              </div>
            </b-alert>
          </div>

          <!-- Fleet Selected -->
          <div class="mb-5 d-flex flex-wrap">
            <div
              class="d-flex"
              style="width: 220px"
              v-for="(fleet, i) in activeSelectedFleets"
              :key="i"
            >
              <div class="text-center">
                <label>
                  <img
                    :src="require('@src/assets/images/fleet/PusherBarge.png')"
                    alt="#"
                    class="img-fluid"
                    style="width: 200px; height: auto"
                  />
                </label>
                <div class="d-flex align-items-center justify-content-center">
                  <b-form-checkbox
                    :value="fleet.vehicle_id"
                    v-model="fleetIdsChecked"
                  />
                  <strong>{{ fleet.vehicle_name }}</strong>
                </div>
              </div>
            </div>
          </div>
          <!-- Table -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <!-- <div class="d-flex">
              <b-form class="d-flex mb-3">
                <b-form-input
                  id="fleet_name"
                  style="width: 200px"
                  type="text"
                  placeholder="Search equipment name..."
                  v-model="jobList.params.search"
                ></b-form-input>
              </b-form>
              <b-button
                variant="outline-primary"
                class="d-flex align-items-center ml-2"
                style="height: max-content"
                @click="modalFilter = true"
              >
                <i class="fas fa-sliders"></i>
                <p class="text-truncate m-0"> Filter Data</p>
              </b-button>
            </div> -->
            <div>
              <b-button
                variant="danger"
                @click="handleBulkDelete"
                :disabled="!hasCheckedItems"
              >
                <i class="fa fa-trash-alt mr-2"></i>
                Bulk Delete
              </b-button>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="sticky-col sticky-col-1">
                    <b-form-checkbox
                      class="d-flex justify-content-center"
                      :checked="isCheckedAll"
                      @change="toggleSelectAll"
                    />
                  </th>
                  <th class="text-nowrap sticky-col sticky-col-2">
                    Fleet Name
                  </th>
                  <th
                    class="text-nowrap sticky-col sticky-col-3"
                    style="min-width: 240px"
                  >
                    Equipment Name
                  </th>
                  <th class="text-nowrap" style="min-width: 160px">Interval</th>
                  <th class="text-nowrap">
                    Last Maintenance (Date)
                    <span class="text-danger">*</span>
                  </th>
                  <th class="text-nowrap">
                    Last Maintenance (RH)
                    <span class="text-danger">*</span>
                  </th>
                  <th class="text-nowrap" style="min-width: 200px">
                    Last Attachment
                  </th>
                  <th class="text-nowrap">Equipment Category</th>
                  <th class="text-nowrap">Job Type</th>
                  <th>Method</th>
                  <th class="text-nowrap">Engine Position</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paginatedForms.length === 0">
                  <td
                    :colspan="11"
                    class="sticky-col sticky-col-1 text-muted py-4"
                  >
                    No data available. Please select at least one fleet and
                    adjust filters if needed.
                  </td>
                </tr>
                <template v-else>
                  <tr v-for="(job, index) in paginatedForms" :key="index">
                    <td class="sticky-col sticky-col-1">
                      <b-form-checkbox
                        type="checkbox"
                        :value="job.unique_id"
                        v-model="checkedJobs"
                        class="d-flex justify-content-center"
                      />
                    </td>
                    <td class="sticky-col sticky-col-2">
                      <b-badge variant="success">
                        {{ job.vehicle_name }}
                      </b-badge>
                    </td>
                    <td class="sticky-col sticky-col-3">
                      {{
                        job.job_libraries.maintenance_master?.equipment_name ||
                        'N/A'
                      }}
                      <br />
                      <small v-if="job.job_libraries.method === 'COUNTER'">
                        {{ job.job_libraries.power_series_name }}
                      </small>
                    </td>
                    <td>
                      <InputCurrency
                        v-if="job.job_libraries.method == 'CALENDAR'"
                        class="text-sm"
                        prepend=""
                        :append="
                          formatCalendarType(job.job_libraries.calendar_type)
                        "
                        v-model="job.job_libraries.calendar_interval"
                        required
                      ></InputCurrency>
                      <InputCurrency
                        v-else
                        class="text-sm"
                        prepend=""
                        :append="'Hours'"
                        v-model="job.job_libraries.interval_hour"
                        required
                      ></InputCurrency>
                    </td>
                    <td>
                      <date-picker
                        style="width: 200px"
                        v-model="job.job_libraries.last_maintenance_date"
                        type="date"
                        value-type="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        :disabled-date="disableFutureDates"
                        @input="handleDateChange(job.job_libraries, $event)"
                        :input-attr="{ required: true }"
                      />
                    </td>
                    <td>
                      <template v-if="job.job_libraries.method === 'COUNTER'">
                        <InputCurrency
                          class="text-sm"
                          prepend=""
                          :append="'Hours'"
                          required
                          v-model="
                            job.job_libraries.last_maintenance_interval_hour
                          "
                        ></InputCurrency>
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td style="min-width: 400px">
                      <b-form-file
                        v-model="job.job_libraries.attachment"
                        multiple
                      ></b-form-file>
                    </td>
                    <td class="text-nowrap">
                      {{
                        job.job_libraries.maintenance_master?.equipment_name ||
                        'N/A'
                      }}
                    </td>
                    <td class="text-nowrap">
                      {{
                        job.job_libraries.maintenance_job_type
                          ?.job_type_index || 'N/A'
                      }}
                    </td>
                    <td class="text-nowrap">
                      {{ job.job_libraries.method || 'Calendar' }}
                    </td>
                    <td class="text-nowrap">
                      {{ job.job_libraries?.power_type_name || '-' }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <div
            class="my-4 d-flex align-items-center w-100 justify-content-between"
          >
            <p>
              Total Rows:
              <strong class="text-black fw-bold">{{ totalRows }}</strong>
            </p>
            <div class="d-flex align-items-center">
              <b-pagination
                class="mb-0 mr-3"
                v-model="jobList.params.page"
                :total-rows="totalRows"
                :per-page="jobList.params.limit"
                first-number
                align="center"
                @change="onPageChange"
              ></b-pagination>
              <b-form-select
                plain
                v-model="jobList.params.limit"
                :options="limitOptions"
                style="width: 140px"
                @change="onLimitChange"
              ></b-form-select>
            </div>
          </div>

          <div class="d-flex">
            <b-button
              variant="outline-primary"
              class="w-50 mr-2"
              @click="$emit('close')"
            >
              Cancel
            </b-button>
            <b-button variant="primary" type="submit" class="w-50">
              Save
            </b-button>
          </div>
        </form>
      </template>
    </iq-card>
  </div>
</template>

<script>
import { limitOptions } from '@/src/core/mock/data/optionsData'
import { fleetsActions, pmsActions } from '@/src/Utils/helper'
import InputCurrency from '@/src/components/global/InputCurrency.vue'

export default {
  components: { InputCurrency },
  props: {
    selectedFleets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSidebar: false,
      fleetIdsChecked: [],
      limitOptions,
      jobList: {
        params: {
          search: '',
          vehicleTypeIds: [],
          active: true,
          page: 1,
          limit: 50,
          total: 10,
          totalPages: 1,
        },
        data: [{}],
      },
      forms: [
        {
          vehicle_id: '',
          job_libraries: {
            id: '',
            method: 'CALENDAR',
            counter_trigger_id: null,
            vehicle_power_id: null,
            power_type_id: null,
            power_series_id: null,
            calendar_interval: 40,
            interval_hour: null,
            interval_minutes: null,
            last_maintenance_date: '2025-03-01',
            last_maintenance_interval_hour: null,
            last_maintenance_interval_minutes: null,
          },
        },
      ],
      checkedJobs: [],
      modalFilter: false,
      modalFleet: false,
      notMatchVehicleEngines: [],
    }
  },
  computed: {
    filteredData() {
      return this.jobList.data.filter((job) =>
        job.name.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    filteredForms() {
      // Jika tidak ada fleet yang ter-checklist, jangan tampilkan form apapun
      if (!this.fleetIdsChecked || this.fleetIdsChecked.length === 0) {
        return []
      }

      // Filter forms berdasarkan fleet yang di-checklist
      let filtered = this.forms.filter((form) =>
        this.fleetIdsChecked.includes(form.vehicle_id)
      )

      // Filter berdasarkan search equipment name
      if (
        this.jobList.params.search &&
        this.jobList.params.search.trim() !== ''
      ) {
        const searchTerm = this.jobList.params.search.toLowerCase().trim()
        filtered = filtered.filter((form) => {
          const equipmentName =
            form.job_libraries?.maintenance_master?.equipment_name ||
            form.job_libraries?.name ||
            ''
          return equipmentName.toLowerCase().includes(searchTerm)
        })
      }

      return filtered
    },
    paginatedForms() {
      const start = (this.jobList.params.page - 1) * this.jobList.params.limit
      const end = start + this.jobList.params.limit
      return this.filteredForms.slice(start, end)
    },
    totalRows() {
      return this.filteredForms.length
    },
    totalPages() {
      return Math.ceil(this.filteredForms.length / this.jobList.params.limit)
    },
    isCheckedAll() {
      return (
        this.paginatedForms.length > 0 &&
        this.paginatedForms.every((form) =>
          this.checkedJobs.some((jobId) => jobId == form.unique_id)
        )
      )
    },
    hasCheckedItems() {
      return this.checkedJobs.length > 0
    },
    activeSelectedFleets() {
      // Filter selectedFleets berdasarkan vehicle_id yang masih ada di forms
      const activeVehicleIds = [
        ...new Set(this.forms.map((form) => form.vehicle_id)),
      ]
      return this.selectedFleets.filter((fleet) =>
        activeVehicleIds.includes(fleet.vehicle_id)
      )
    },
    groupedNotMatchEngines() {
      // Group by engine_id dan kumpulkan unique vehicle_names
      const grouped = {}

      this.notMatchVehicleEngines.forEach((item) => {
        const engineId = item.engine_id
        if (!grouped[engineId]) {
          grouped[engineId] = {
            engine_id: engineId,
            engine_name: item.engine_name || `Engine ${engineId}`,
            vehicle_names: new Set(),
          }
        }
        grouped[engineId].vehicle_names.add(item.vehicle_name)
      })

      // Convert Set to Array dan return sebagai array
      return Object.values(grouped).map((group) => ({
        ...group,
        vehicle_names: Array.from(group.vehicle_names),
      }))
    },
  },
  watch: {
    'jobList.params.search'() {
      this.jobList.params.page = 1
    },
    activeSelectedFleets(newFleets) {
      // Update fleetIdsChecked ketika activeSelectedFleets berubah
      this.fleetIdsChecked = newFleets.map((fleet) => fleet.vehicle_id)
    },
  },
  methods: {
    ...fleetsActions,
    ...pmsActions,
    disableFutureDates(date) {
      // Disable all dates after today
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },
    handleDateChange(jobLibrary, inputValue) {
      this.validateMaintenanceDate(jobLibrary, inputValue)
      this.fetchActualRhByDate(jobLibrary)
    },
    async fetchActualRhByDate(row, method) {
      if (row.method !== 'COUNTER') {
        return false
      }
      try {
        const res = await this.getRhByDate({
          vehicle_power_id: row.vehicle_power_id,
          power_series_id: row.power_series_id,
          power_type_id: row.power_type_id,
          date: row.last_maintenance_date,
        })
        if (res.status === 'success') {
          const { data } = res.data
          row.last_maintenance_interval_hour = data.total_running_hours
        }
      } catch (error) {
        console.log('Error fetching actual running hours:', error)
      }
    },
    getCurrentDate() {
      // Return today's date in YYYY-MM-DD format
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    validateMaintenanceDate(jobLibrary, inputValue) {
      const today = new Date()
      const inputDate = new Date(inputValue)

      today.setHours(0, 0, 0, 0)
      inputDate.setHours(0, 0, 0, 0)

      if (inputDate > today) {
        jobLibrary.last_maintenance_date = this.getCurrentDate()
        this.$swal(
          'Invalid Date',
          'Last maintenance date cannot be in the future. Date has been set to today.',
          'warning'
        )
      }
    },
    toggleSelectAll(checked) {
      const currentPageIds = this.paginatedForms.map((form) => form.unique_id)
      if (checked) {
        const unique = new Set([...this.checkedJobs, ...currentPageIds])
        this.checkedJobs = Array.from(unique)
      } else {
        this.checkedJobs = this.checkedJobs.filter(
          (id) => !currentPageIds.includes(id)
        )
      }
    },
    deleteJob(job) {
      alert('Delete: ' + job.name)
    },
    clearSearch() {
      this.jobList.params.search = ''
    },
    onPageChange(page) {
      this.jobList.params.page = page
    },
    onLimitChange() {
      // Reset ke halaman pertama ketika limit berubah
      this.jobList.params.page = 1
    },
    formatCalendarType(calendarType) {
      if (!calendarType) return 'Month'

      // Convert capital letters to capitalize
      return (
        calendarType.charAt(0).toUpperCase() +
        calendarType.slice(1).toLowerCase()
      )
    },

    initializeForms() {
      // Initialize forms dengan data dari selectedFleets
      this.forms = this.selectedFleets
        .map((fleet) => {
          // Create forms untuk setiap available job library
          let jobLibraryForms = []

          fleet.available_job_library_ids.forEach((jobLibrary) => {
            // Jika method adalah COUNTER, cek apakah ada matches untuk multiple forms
            if (jobLibrary.method === 'COUNTER') {
              const counterTrigger =
                fleet.counter_trigger.by_job_library_id[jobLibrary.id]

              if (
                counterTrigger &&
                counterTrigger.matches &&
                counterTrigger.matches.length > 0
              ) {
                // Filter matches - hanya yang exists_in_pms_vehicle = false
                const availableMatches = counterTrigger.matches.filter(
                  (match) => match.exists_in_pms_vehicle === false
                )

                if (availableMatches.length > 0) {
                  // Buat form untuk setiap match yang available (exists_in_pms_vehicle = false)
                  availableMatches.forEach((match) => {
                    const triggerData =
                      counterTrigger.triggers?.find(
                        (el) => el.id === match.counter_trigger_id
                      ) || {}

                    jobLibraryForms.push({
                      vehicle_id: fleet.vehicle_id,
                      vehicle_name: fleet.vehicle_name,
                      vehicle_code: fleet.vehicle_code,
                      vehicle_type: fleet.vehicle_type,
                      // ID unik gabungan vehicle_id, job_library_id dan vehicle_power_id untuk counter
                      unique_id: `${fleet.vehicle_id}_${jobLibrary.id}_${match.vehicle_power_id}`,
                      job_libraries: {
                        id: jobLibrary.id,
                        name: jobLibrary.name,
                        code: jobLibrary.code,
                        method: jobLibrary.method,
                        calendar_type: jobLibrary.calendar_type,
                        calendar_interval: jobLibrary.calendar_interval,
                        job_description: jobLibrary.job_description,
                        maintenance_master: jobLibrary.maintenance_master,
                        maintenance_job_class: jobLibrary.maintenance_job_class,
                        maintenance_job_type: jobLibrary.maintenance_job_type,
                        // Form fields for counter method
                        counter_trigger_id: match.counter_trigger_id || null,
                        vehicle_power_id: match.vehicle_power_id || null,
                        power_type_id: match.power_type_id || null,
                        power_series_id: match.power_series_id || null,
                        power_series_name: match.power_series_name || null,
                        power_type_name: match.power_type_name || null,
                        interval_hour: triggerData.interval_hour || null,
                        interval_minutes: triggerData.interval_minutes || null,
                        last_maintenance_date:
                          match.last_maintenance_date || null,
                        last_maintenance_interval_hour: null,
                        last_maintenance_interval_minutes: null,
                        attachment: [],
                      },
                      counter_trigger: counterTrigger,
                    })
                  })
                }
              } else {
                // Jika tidak ada matches, simpan untuk notifikasi
                const triggers = counterTrigger.triggers
                if (triggers?.length) {
                  triggers.forEach((trigger) => {
                    this.notMatchVehicleEngines.push({
                      engine_name: trigger?.power_type?.name || '',
                      engine_id: trigger?.power_type_id || '',
                      vehicle_name: fleet.vehicle_name,
                    })
                  })
                }
              }
              // Jika tidak ada matches untuk counter method, skip (jangan tambahkan ke forms)
            } else {
              // Untuk method CALENDAR, buat satu form normal
              jobLibraryForms.push({
                vehicle_id: fleet.vehicle_id,
                vehicle_name: fleet.vehicle_name,
                vehicle_code: fleet.vehicle_code,
                vehicle_type: fleet.vehicle_type,
                unique_id: `${fleet.vehicle_id}_${jobLibrary.id}`,
                job_libraries: {
                  id: jobLibrary.id,
                  name: jobLibrary.name,
                  code: jobLibrary.code,
                  method: jobLibrary.method || 'CALENDAR',
                  calendar_type: jobLibrary.calendar_type,
                  calendar_interval: jobLibrary.calendar_interval,
                  job_description: jobLibrary.job_description,
                  maintenance_master: jobLibrary.maintenance_master,
                  maintenance_job_class: jobLibrary.maintenance_job_class,
                  maintenance_job_type: jobLibrary.maintenance_job_type,
                  // Form fields not needed for calendar method
                  counter_trigger_id: null,
                  vehicle_power_id: null,
                  power_type_id: null,
                  power_series_id: null,
                  interval_hour: null,
                  interval_minutes: null,
                  last_maintenance_date:
                    jobLibrary.last_maintenance_date || null,
                  last_maintenance_interval_hour: null,
                  last_maintenance_interval_minutes: null,
                  attachment: [],
                },
                counter_trigger:
                  fleet.counter_trigger.by_job_library_id[jobLibrary.id] ||
                  null,
              })
            }
          })

          return jobLibraryForms
        })
        .flat() // Flatten array karena setiap fleet bisa punya multiple job libraries
    },

    async handleUploadFiles(files) {
      const formData = new FormData()
      for (const file of files) {
        formData.append('files', file)
      }
      const res = await this.uploadFilePmsMultiple(formData)
      return res.data?.data?.files || []
    },

    async handleSubmit() {
      try {
        // Filter forms sesuai fleet yang ter-checklist
        const selectedIds = new Set(this.fleetIdsChecked || [])
        const formsToSubmit = this.forms.filter((el) =>
          selectedIds.has(el.vehicle_id)
        )

        // Validasi jika tidak ada forms yang sesuai pilihan fleet
        if (formsToSubmit.length === 0) {
          this.$swal(
            'Warning!',
            'No job assignments found for the selected fleets.',
            'warning'
          )
          return
        }

        // Validasi last maintenance date harus terisi
        const invalidForms = formsToSubmit.filter(
          (el) => !el.job_libraries.last_maintenance_date
        )
        if (invalidForms.length > 0) {
          this.$swal(
            'Warning!',
            'Please fill in Last Maintenance Date for all job assignments.',
            'warning'
          )
          return
        }

        // Submit semua data forms (tidak berdasarkan checkbox selection)
        const body = await Promise.all(
          formsToSubmit.map(async (el) => ({
            vehicle_id: el.vehicle_id,
            job_libraries: {
              id: el.job_libraries.id,
              method: el.job_libraries.method,
              counter_trigger_id: el.job_libraries.counter_trigger_id,
              vehicle_power_id: el.job_libraries.vehicle_power_id,
              power_type_id: el.job_libraries.power_type_id,
              power_series_id: el.job_libraries.power_series_id,
              calendar_interval: el.job_libraries.calendar_interval,
              interval_hour: el.job_libraries.interval_hour,
              interval_minutes: el.job_libraries.interval_hour
                ? Number(el.job_libraries.interval_hour) * 60
                : null,
              last_maintenance_date: el.job_libraries.last_maintenance_date,
              last_maintenance_interval_hour:
                el.job_libraries.last_maintenance_interval_hour,
              last_maintenance_interval_minutes:
                Number(el.job_libraries.last_maintenance_interval_hour) * 60,
              attachment: await this.handleUploadFiles(
                el.job_libraries.attachment?.length
                  ? el.job_libraries.attachment
                  : []
              ),
            },
          }))
        )

        const res = await this.assignJobLibraryToVehilcle(body)

        if (res?.status === 'success') {
          this.$swal(
            'Success!',
            res.message ||
              `${this.forms.length} job assignments prepared for submission.`,
            'success'
          )
          this.$emit('close')
          this.$emit('refetch')
          this.$router.push('/maintenance/maintenance-transactional')
        } else {
          this.$swal('Oops!', res.data || 'Submission failed.', 'error')
        }
      } catch (error) {
        console.log('Error submitting job assignments:', error)
        this.$swal(
          'Error!',
          'Something went wrong while submitting data.',
          'error'
        )
      }
    },
    handleBulkDelete() {
      // Validasi jika tidak ada yang dipilih untuk dihapus
      if (this.checkedJobs.length === 0) {
        this.$swal(
          'Warning!',
          'Please select at least one row to delete.',
          'warning'
        )
        return
      }

      // Konfirmasi bulk delete
      this.$swal({
        title: 'Are you sure?',
        text: `You are about to delete ${this.checkedJobs.length} job assignment(s). This action cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete them!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.forms = this.forms.filter(
            (form) => !this.checkedJobs.includes(form.unique_id)
          )
          this.checkedJobs = []

          const totalPages = Math.ceil(
            this.filteredForms.length / this.jobList.params.limit
          )
          if (this.jobList.params.page > totalPages && totalPages > 0) {
            this.jobList.params.page = totalPages
          }

          this.$swal(
            'Deleted!',
            'Selected job assignments have been deleted.',
            'success'
          )
        }
      })
    },
  },

  mounted() {
    this.fleetIdsChecked = this.selectedFleets.map((fleet) => fleet.vehicle_id)
    this.initializeForms()
  },
}
</script>

<style scoped>
.table td,
.table th {
  vertical-align: middle;
}
.badge {
  font-size: 0.8rem;
  padding: 0.4em 0.6em;
}

/* Sticky columns styles */
.sticky-col {
  position: sticky;
  background-color: #f8f9fa; /* Same as thead-light */
  z-index: 10;
}

.sticky-col-1 {
  left: 0;
  min-width: 60px;
  width: 60px;
}

.sticky-col-2 {
  left: 60px;
  min-width: 120px;
  width: 120px;
}

.sticky-col-3 {
  left: 180px;
  min-width: 240px;
  width: 240px;
}

/* Untuk tbody, background putih */
tbody .sticky-col {
  background-color: #ffffff;
}

/* Border untuk memisahkan sticky columns */
.sticky-col-3::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 2px;
  background-color: #dee2e6;
}

/* Hover effect untuk baris */
.table-hover tbody tr:hover .sticky-col {
  background-color: #f5f5f5;
}
</style>
